export function Plane(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2144 0.884893C14.23 0.32702 15.4611 1.11177 15.384 2.26795L14.7883 11.2029C14.7026 12.4888 13.505 13.4056 12.2413 13.1529L2.31552 11.1677C0.364124 10.7774 -0.0374051 8.16409 1.70682 7.20599L13.2144 0.884893ZM13.6567 4.12408L7.66681 10.6063L12.5551 11.5839C12.871 11.6471 13.1704 11.4179 13.1919 11.0964L13.6567 4.12408ZM5.82811 10.2385L12.3413 3.18998L2.47713 8.60835C2.04107 8.84788 2.14146 9.50121 2.62931 9.59878L5.82811 10.2385Z"
          fill="currentColor"
        />
        <path
          d="M4.88899 11.3332L9.88899 11.7142L7.02901 15.057C6.68349 15.4609 6.02744 15.3178 5.88143 14.8068L4.88899 11.3332Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
